import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Account } from '../../../models/common/trading-common.model';
import { TradingService } from '../../../services/common/trading-service.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'accountInfo-component',
    templateUrl: './accountInfo.component.html',
    styleUrls: ['./accountInfo.component.css']
})

/**
 * The Holdings component to take care of rendering the Holdings section for all asset types.
 */
export class AccountInfoComponent implements OnInit, OnDestroy {
    address: string;
    @Input() isMobileDialog: boolean = false;
    regType: string;
    private accountSub: Subscription;
    showRegType: boolean;
    activeTheme: string;

    constructor(private tradingService: TradingService) {
    }
    ngOnInit() {
        this.accountSub = this.tradingService.accountSubject$.subscribe((data: Account) => this.onAccount(data));
    }

    private onAccount(account: Account): void {
        this.activeTheme = this.tradingService.getActiveThemeFromCurrentContainer();
        this.showRegType = false;
        this.address = '';
        this.regType = '';
        if (!!account && account.acctNum) {
            this.address = account.acctAddress;
            if (account.regTypeDescription) {
                this.showRegType = true;
                this.regType = account.regTypeDescription;
            }
        }
    }

   // Destroys all the subscription handles
    ngOnDestroy(): void {
        if ( !!this.accountSub ) {
            this.accountSub.unsubscribe();
        }
    }
}
